import React from "react";
import { Link } from "react-router-dom";

const PostJob: React.FC = () => {
  return (
    <section className="bg-gray-50 min-h-screen">
      <div className="max-w-2xl mx-auto px-6 py-16 text-center">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-4">
          Tell us what you need done
        </h1>
        <p className="text-gray-600 mb-8">
          Search for a handyman by state, LGA and service type, or find
          someone near you right now. You'll see their profile, reviews and
          price before you book - no waiting for quotes.
        </p>

        <Link
          to="/search"
          className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg"
        >
          Find a Handyman
        </Link>

        <p className="text-sm text-gray-500 mt-6">
          Own a skill and want work instead?{" "}
          <Link
            to="/register-provider"
            className="text-green-700 font-medium hover:underline"
          >
            List your business
          </Link>
        </p>
      </div>
    </section>
  );
};

export default PostJob;
